<template>
  <div v-if="renderComponent">
    <div>
      <h5 class="vue-title pull-left custom-header">
        <strong>{{ $t("SERVICECATEGORYMASTER") }}</strong>
      </h5>
     
      <b-input-group 
        class="pull-right search-text-box search-service"
      >
        <template v-slot:prepend>
          <b-input-group-text @click="onSerach">
            <em class="fa fa-search"></em>
          </b-input-group-text>
        </template>
        <b-form-input
          size="sm"
          @keyup.enter="onSerach"
          autocomplete="off"
          v-model="searchKeyword"
        ></b-form-input>
      </b-input-group>
    </div>

    <c-table
      :table-data="serviceCategoryMaster.list"
      :fields="tableHeaders"
      :per-page="10"
      striped
      hover
      :edit="editSelectedRow"
      :total="serviceCategoryMaster.pageTotal"
      :sortTable="sortTable"
      :isBusy="isBusy"
      :pagination="pagination"
      :update="showStatusModal"
      :countPerPage="currentPage"
    ></c-table>
      <nav>
      <div class="pagination-module">
        <b-pagination
          :total-rows="serviceCategoryMaster.pageTotal"
          @change="pagination"
          :per-page="10"
          v-model="currentPage"
          :prev-text="$t('FORWARD')"
          :next-text="$t('NEXT')"
        />
      </div>
    </nav>

    <b-modal id="modal-delete" hide-footer>
      <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
      <p class="my-2 wrapText">
        {{ selectedServiceMaster.name }} {{ $t("DELETECONFIRMATIONCOMMOM") }}
      </p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-danger"
            class="buttons-align-right"
            size="sm"
            @click="deleteTableRowData()"
            >{{ $t("DELETE") }}</b-button
          >
          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="$bvModal.hide('modal-delete')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-Status" hide-footer @hidden="close">
      <template v-slot:modal-title>{{
        $t("STATUSCHANGECONFIRMATION")
      }}</template>
      <p>ステータスを変更してもよろしいですか？</p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right"
            @click="statusChangeOfTableRow()"
          >
            {{ $t("SUBMIT") }}
          </b-button>

          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="close"
          >
            {{ $t("CANCEL") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  DELETE_SERVICE_CATEGORY_MASTER,
  SERVICE_CATEGORY_LIST,
  UPDATE_STATUS_SERVICE_CATEGORY
} from "@/store/actions.type";
import cTable from "@/components/Table.vue";
import { checkPermisssion } from "@/shared/utils.js";

export default {
  name: "service",
  data() {
    return {
      searchKeyword: "",
      currentPage: 1,
      checkPermisssion: checkPermisssion,
      tableHeaders: [],
      selectedServiceMaster: "",
      sortField: "",
      sortDirection: false,
      isLoading: "",
      isBusy: true,
      renderComponent: true
    };
  },
  computed: {
    ...mapGetters(["serviceCategoryMaster"])
  },
  /* Initilization of Imported Components*/
  components: { cTable },
  methods: {
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    deleteServiceMaster(row) {
      this.selectedServiceMaster = row;
      this.$bvModal.show("modal-delete");
    },
    /**
     * Edit the table row
     * Input @param {Number} userId Seleted Row id to Edit
     * Output  @param {Number} userId  append to routing Params then Redirect to edit page
     */
    editSelectedRow(row) {
      this.$router.push({
        name: "editService",
        params: { id: row.id }
      });
    },

    /**
     * Delete function for table Row
     * Input @param {Number} userID selected Row ID
     * Output @param {String}   data.status  Boolean status Api call
     */
    deleteTableRowData() {
      this.$toast.removeAll();
      this.$bvModal.hide("modal-delete");

      this.isLoading = this.$loading.show({
        loader: "dots",
        color: "#007bff"
      });
      this.$store
        .dispatch(DELETE_SERVICE_CATEGORY_MASTER, {
          //Delete Api Call
          id: this.selectedServiceMaster.id
        })
        .then(data => {
          this.isLoading.hide();
          if (data.status) {
            this.$toast.success({
              message: data.message
            });
            this.$store.dispatch(SERVICE_CATEGORY_LIST, {
              search_query: this.searchKeyword,
              page: this.currentPage,
              field: this.sortField,
              sort: this.sortDirection
            });
          } else {
            this.$toast.error({
              message: data.message
            });
          }
        });
    },
    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
      this.$store
        .dispatch(SERVICE_CATEGORY_LIST, {
          search_query: this.searchKeyword,
          page: this.currentPage,
          field: this.sortField,
          sort: this.sortDirection
        })
        .then(data => {
          this.isBusy = false;
        });
    },
    /* Pagintaion */
    pagination(page) {
      this.currentPage = page;
      this.isBusy = true;
      this.$store
        .dispatch(SERVICE_CATEGORY_LIST, {
          search_query: this.searchKeyword,
          page: this.currentPage,
          field: this.sortField,
          sort: this.sortDirection
        })
        .then(data => {
          this.isBusy = false;
        });
    },
    /**
     * Show Status Change Modal
     * Input @param {object} row Seleted Row to Change status of it
     * Output PopUp the Status Change Modal
     */
    showStatusModal(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-Status");
    },
    /**
     * Status function for table Row
     * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
     * Output @param {boolean}   data.status  status of the api call (true or false)
     */
    statusChangeOfTableRow() {
      this.$toast.removeAll();
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let selectedItemId = _.get(this.selectedItemForDelete, "id", 0);
      this.$bvModal.hide("modal-Status");

      if (selectedItemId) {
        let status = _.get(this.selectedItemForDelete, "status", "");
        this.$store
          .dispatch(UPDATE_STATUS_SERVICE_CATEGORY, {
            //Status Update Api call
            id: selectedItemId,
            status: status == "active" ? "inactive" : "active"
          })
          .then(data => {
            this.isLoading.hide();
            if (data.status) {
              this.$toast.success({
                title: this.$t("SUCCESSFULLYUPDATED"),
                message: data.message
              });
            } else {
              this.$toast.error({
                title: this.$t("ERROR"),
                message: data.message
              });
            }
          });
        this.isBusy = true;
        this.$store
          .dispatch(SERVICE_CATEGORY_LIST, {
            search_query: this.searchKeyword,
            page: this.currentPage,
            field: this.sortField,
            sort: this.sortDirection
          })
          .then(data => {
            this.isBusy = false;
          });
      } else {
        this.$bvModal.hide("modal-Status");
        this.isLoading.hide();
      }
    },
    /*Compomonet Rerendering */
    close() {
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
    this.pagination(1);
    }
  },
  created() {
    this.$toast.removeAll();
    this.$store
      .dispatch(SERVICE_CATEGORY_LIST, { field: "id", sort: "desc" })
      .then(data => {
        this.isBusy = false;
      });
    this.tableHeaders = [
      { key: "id", label: this.$t("ID"), sortable: true, class: "text-left" },
      {
        key: "parent_name",
        label: this.$t("SERVICECATEGORYNAME"),
        class: "text-left",
        sortable: true
      },
      {
        key: "name",
        label: this.$t("SUBCATEGORY"),
        sortable: true,
        class: "text-left"
      },
      { key: "icon", label: this.$t("ICON"), sortable: false }
    ];
    if (checkPermisssion("MASTER", "MASTER_SERVICE")) {
      this.tableHeaders.push({
        key: "custom_actions",
        label: this.$t("ACTION"),
        sortable: false
      });
    }
  }
};
</script>
<style>
.search-service{
    width:200px;margin:10px 00px;
  }

</style>